import { BaseProgressionStrategy } from './BaseProgressionStrategy.js';

export class LofiProgressionStrategy extends BaseProgressionStrategy {
  build(ctx) {
    if (ctx.scale.length >= 7) {
      const choice = this.pick(ctx, [[1, 4, 0, 5], [0, 3, 1, 4], [3, 0, 1, 4]]);
      return choice.map(deg => this.seventh(ctx, deg));
    }
    return [this.seventh(ctx, 0), this.seventh(ctx, 3)];
  }
}
